import translator from "@/translator";
import React from "react";
import { Dropdown, Button } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";

const t = translator("note_office.views.services.dropdown_menu.");

const DropdownMenu = ({ totalServices }) => {
  const handleMenuClick = (e) => {
    const url = new URL(window.location.href);
    if (e.key === "services_copy" && totalServices !== 0) {
      url.searchParams.set("mode", "copy");
      window.location.href = url.toString();
    }
    if (e.key === "services_delete" && totalServices !== 0) {
      url.searchParams.set("mode", "delete");
      window.location.href = url.toString();
    }
  };

  const menuItems = [
    { key: "services_copy", label: t("services_copy") },
    { key: "services_delete", label: t("services_delete") },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems, onClick: handleMenuClick }}
      trigger={["click"]}
      overlayClassName="dropdown-menu__menu"
    >
      <Button type="text" icon={<EllipsisOutlined className="dropdown-menu__btn" />} />
    </Dropdown>
  );
};

export default DropdownMenu;
